function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import Draft from 'draft-js';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { debounce } from '@finect/front-utils/debounce';
import { cancelablePromise } from '@finect/front-utils/cancelablePromise';
import { Suggestions, SuggestionItem } from '@finect/tabular-components/Suggestions';
import { ProductItem } from '@finect/tabular-components/ProductItem';
import { EntityProduct } from './EntityProduct';
export var Product = function (_React$Component) {
  _inherits(Product, _React$Component);
  var _super = _createSuper(Product);
  function Product() {
    var _this;
    _classCallCheck(this, Product);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "entityContainer", void 0);
    _defineProperty(_assertThisInitialized(_this), "length", 0);
    _defineProperty(_assertThisInitialized(_this), "pendingPromises", []);
    _defineProperty(_assertThisInitialized(_this), "state", {
      suggestions: [],
      showSuggestions: false,
      selectedSuggestion: 0,
      entityWidth: 0
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.pendingPromises.map(function (promise) {
        return promise.cancel();
      });
      _this.deleteCallbacks();
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.entityKey) return;
      _this.length = _this.props.decoratedText.length;
      var searchTerm = _this.props.decoratedText.trim().substring(1);
      _this.getSuggestions(searchTerm);
    });
    _defineProperty(_assertThisInitialized(_this), "appendPendingPromise", function (promise) {
      return _this.pendingPromises = [].concat(_toConsumableArray(_this.pendingPromises), [promise]);
    });
    _defineProperty(_assertThisInitialized(_this), "removePendingPromise", function (promise) {
      return _this.pendingPromises = _this.pendingPromises.filter(function (pendingPromise) {
        return pendingPromise !== promise;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "processPromise", function (wrappedPromise) {
      wrappedPromise.promise.then(function (products) {
        if (products) {
          _this.setState({
            suggestions: products.slice(0, 5),
            showSuggestions: true,
            selectedSuggestion: 0,
            entityWidth: _this.entityContainer ? _this.entityContainer.getBoundingClientRect().width : 0
          });
          _this.props.editor.callbacks = {
            onEscape: _this.handleEscape,
            onTab: _this.handleSelection,
            onReturn: _this.handleSelection,
            onDownArrow: _this.handleDownArrow,
            onUpArrow: _this.handleUpArrow
          };
        } else {
          _this.hideSuggestions();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "createEntityProduct", function (product) {
      var _this$props = _this.props,
        contentState = _this$props.contentState,
        decoratedText = _this$props.decoratedText;
      var selectionState = contentState.getSelectionAfter();
      var end = selectionState.getEndOffset();
      var start = end - decoratedText.length;
      var handleSelection = selectionState.merge({
        anchorOffset: start,
        focusOffset: end
      });
      var isCaps = product.entity.name === product.entity.name.toUpperCase();
      var name = isCaps ? product.entity.name.toLowerCase().replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      }) : product.entity.name;
      var newProduct = {
        id: product.entity.id,
        subtype: product.subtype,
        name: name,
        link: product.entity.link && product.entity.link.href || product.entity.web
      };
      var handleEntity = contentState.createEntity('PRODUCT_MENTION', 'IMMUTABLE', newProduct);
      var entityKey = handleEntity.getLastCreatedEntityKey();
      var newContentState = Draft.Modifier.replaceText(handleEntity, handleSelection, name, null, entityKey);
      var newEditorState = Draft.EditorState.push(_this.props.editor.state.editorState, newContentState, 'insert-characters');
      var editorStateToUpdate = Draft.EditorState.forceSelection(newEditorState, newContentState.getSelectionAfter());
      _this.props.editor.handleAddEntity(product);
      _this.props.editor.setState({
        editorState: editorStateToUpdate
      });
    });
    _defineProperty(_assertThisInitialized(_this), "clickedProduct", function (index) {
      _this.createEntityProduct(_this.state.suggestions[index]);
      _this.hideSuggestions();
    });
    _defineProperty(_assertThisInitialized(_this), "fetchProduct", debounce(function (searchProduct) {
      return finectAPI({
        version: 'v4',
        path: "search/products?q=".concat(searchProduct),
        method: 'GET',
        onSuccess: function onSuccess(search) {
          if (search.data.length > 0) return search.data;
          return null;
        }
      });
    }, 200));
    _defineProperty(_assertThisInitialized(_this), "getSuggestions", function (searchTerm) {
      var wrappedPromise = cancelablePromise(_this.fetchProduct(searchTerm));
      _this.appendPendingPromise(wrappedPromise);
      _this.processPromise(wrappedPromise);
    });
    _defineProperty(_assertThisInitialized(_this), "deleteCallbacks", function () {
      _this.props.editor.callbacks = {
        onEscape: null,
        onTab: null,
        onReturn: null,
        onDownArrow: null,
        onUpArrow: null
      };
    });
    _defineProperty(_assertThisInitialized(_this), "hideSuggestions", function () {
      _this.setState({
        showSuggestions: false
      });
      _this.deleteCallbacks();
    });
    _defineProperty(_assertThisInitialized(_this), "handleEscape", function () {
      _this.hideSuggestions();
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelection", function () {
      _this.clickedProduct(_this.state.selectedSuggestion);
    });
    _defineProperty(_assertThisInitialized(_this), "handleDownArrow", function () {
      _this.setState(function (state) {
        return {
          selectedSuggestion: state.selectedSuggestion < state.suggestions.length - 1 ? state.selectedSuggestion + 1 : 0
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleUpArrow", function () {
      _this.setState(function (state) {
        return {
          selectedSuggestion: state.selectedSuggestion > 0 ? state.selectedSuggestion - 1 : state.suggestions.length - 1
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setSelectedSuggestion", function (index) {
      _this.setState({
        selectedSuggestion: index
      });
    });
    return _this;
  }
  _createClass(Product, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.length === nextProps.decoratedText.length) {
        this.pendingPromises.map(function (promise) {
          return promise.cancel();
        });
        this.hideSuggestions();
      }
      if (nextProps.decoratedText !== this.props.decoratedText && !nextProps.entityKey) {
        this.length = nextProps.decoratedText.length;
        var searchTerm = nextProps.decoratedText.substring(1);
        this.getSuggestions(searchTerm.trim());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        suggestions = _this$state.suggestions,
        selectedSuggestion = _this$state.selectedSuggestion,
        entityWidth = _this$state.entityWidth;
      if (this.props.entityKey) {
        var mentionedProduct = this.props.contentState.getEntity(this.props.entityKey).getData();
        return React.createElement(EntityProduct, {
          product: mentionedProduct
        }, this.props.children);
      }
      return React.createElement("span", null, React.createElement("span", {
        ref: function ref(el) {
          return _this2.entityContainer = el;
        }
      }, this.props.children), this.state.suggestions.length > 0 && this.state.showSuggestions ? React.createElement(Suggestions, {
        entityWidth: entityWidth
      }, suggestions.map(function (product, index) {
        return React.createElement(SuggestionItem, {
          key: product.entity.id,
          isSelected: selectedSuggestion === index,
          index: index,
          setSelectedSuggestion: _this2.setSelectedSuggestion,
          clickedSuggestion: _this2.clickedProduct
        }, React.createElement(ProductItem, {
          subtype: product.subtype,
          entity: product.entity
        }));
      })) : null);
    }
  }]);
  return Product;
}(React.Component);